import { useState } from "react";
import Menu from '../menu/Menu';
import TermsConditionsPrivate from "./TermsConditionsPrivate";



export default function TermsConditionsScreenPriavate() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <>
      <TermsConditionsPrivate onOpenMenu={() => setIsMenuOpen(true)} />
      {isMenuOpen && (
        <div className="fixed inset-0 z-50 bg-white">
          <Menu isLoggedIn={true} onClose={() => setIsMenuOpen(false)} />
        </div>
      )}
    </>
  );
}
